import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchCTOData } from "../../redux/reducers/apiSlice";
import ReactVortoxSpinner from "../../components/common-components/ReactVortoxSpinner";
import PaymentLinkTable from "../../components/payment-link-system/PaymentLinkTable";
import {
  convertThenFormat,
  formatDateTimezon,
  // formattedAmount,
  getMonthName,
} from "../../components/common-data/Converts";
// import MealsStructure from "../../components/diet/meal/MealsStructure";
// import UserInfo from "../../components/Open-pages/user/UserInfo";
import ProfileInfo from "../../components/trainer-report/common/ProfileInfo";

const CTODetail = ({ user, prevFilters, gymId, rowData }) => {
  const dispatch = useDispatch();
  const { loading, ctoData, error } = useSelector((state) => state.api);

  const iniGymCto = {
    totalGymCto: 0,
    allGymCtos: [],
  };
  const [gymCTO, setGymCTO] = useState(iniGymCto);

  console.log("gymId=> ", gymId);

  useEffect(() => {
    if (gymId) {
      const updatedFilters = { ...prevFilters };
      // if (!updatedFilters.hasOwnProperty("gym_id")) {
      //   updatedFilters.gym_id = gymId;
      // }
      if (!updatedFilters.gym_id) {
        updatedFilters.gym_id = gymId;
      }

      const filteredParams = Object.entries(updatedFilters)
        .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
        .filter((param) => param.split("=")[1] !== "")
        .join("&");

      dispatch(
        fetchCTOData({ queryParameters: filteredParams, token: user?.token })
      );
    }
  }, [prevFilters, gymId]);

  useEffect(() => {
    if (ctoData?.status && ctoData?.data && !error) {
      setGymCTO((prevs) => ({
        ...prevs,
        totalGymCto: ctoData.total || 0,
        allGymCtos: ctoData.data,
      }));
    } else {
      setGymCTO(iniGymCto);
    }
  }, [ctoData, error]);

  const tbColumns = [
    {
      dataField: "cto_name",
      text: "CTO Name/Type",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            {row?.cto_name || "NA"}{" "}
            <small style={{ fontWeight: "700" }}>
              {" "}
              ({row?.cto_type === "wtf" ? "WTF" : row?.cto_type || ""})
            </small>
          </span>
        );
      },
    },
    {
      dataField: "cto_category",
      text: "CTO Category",
      formatter: (cell, row) => {
        let cost, name, date;
        if (row?.cto_category) {
          const parts = row.cto_category.split(",").map((part) => part.trim());
          cost = parts[0];
          name = parts[2].replace(/"/g, "");
          date = parts[4].replace(/"/g, "");
        }

        return (
          <span className="tb-data">
            {name || "NA"}
            <br />
            {date ? formatDateTimezon(date) : ""}
          </span>
        );
      },
    },
    {
      dataField: "month",
      text: "CTO Month/Year",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            {row?.month ? getMonthName(row.month) : ""}, {row?.year || ""}
          </span>
        );
      },
    },
    {
      dataField: "cost",
      text: "CTO cost",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">₹{convertThenFormat(row?.cost) || 0}</span>
        );
      },
    },
    {
      dataField: "is_fixed",
      text: "Is Fixed",
      formatter: (cell, row) => {
        return (
          <span
            className="tb-data withPadding borderRdius8 bold"
            style={{
              background: row?.is_fixed ? "#F3DADA" : "#45474B",
              color: row?.is_fixed ? "#D90000" : "#fff",
            }}
          >
            {row?.is_fixed ? "Fixed" : "Not Fixed"}
          </span>
        );
      },
    },
    {
      dataField: "document",
      text: "Document",
      formatter: (cell, row) => (
        <div className="actionButtonContainer" style={{ gap: "0" }}>
          <button
            type="button"
            className="actionBtn icon download"
            disabled={row?.document}
            style={{
              cursor: row?.document ? "not-allowed" : "pointer",
            }}
          >
            <a href={row?.document}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-cloud-arrow-down"
                viewBox="0 0 16 16"
                style={{
                  color: row?.document ? "gray" : "#CD0909",
                  minWidth: "35px",
                  minHeight: "35px",
                }}
              >
                <path
                  fillRule="evenodd"
                  d="M7.646 10.854a.5.5 0 0 0 .708 0l2-2a.5.5 0 0 0-.708-.708L8.5 9.293V5.5a.5.5 0 0 0-1 0v3.793L6.354 8.146a.5.5 0 1 0-.708.708z"
                />
                <path d="M4.406 3.342A5.53 5.53 0 0 1 8 2c2.69 0 4.923 2 5.166 4.579C14.758 6.804 16 8.137 16 9.773 16 11.569 14.502 13 12.687 13H3.781C1.708 13 0 11.366 0 9.318c0-1.763 1.266-3.223 2.942-3.593.143-.863.698-1.723 1.464-2.383m.653.757c-.757.653-1.153 1.44-1.153 2.056v.448l-.445.049C2.064 6.805 1 7.952 1 9.318 1 10.785 2.23 12 3.781 12h8.906C13.98 12 15 10.988 15 9.773c0-1.216-1.02-2.228-2.313-2.228h-.5v-.5C12.188 4.825 10.328 3 8 3a4.53 4.53 0 0 0-2.941 1.1z" />
              </svg>
            </a>
          </button>
        </div>
      ),
    },
  ];

  return (
    <>
      {/* <MealsStructure
        text={
          gymCTO.totalGymCto
            ? `Total CTO - ₹${formattedAmount(gymCTO.totalGymCto || 0)}`
            : null
        }
      /> */}

      <ProfileInfo
        info={rowData}
        isGymInfo={true}
        totalGymCto={gymCTO.totalGymCto || 0}
      />

      {loading ? (
        <ReactVortoxSpinner />
      ) : (
        <>
          <div className="overflowAuto separatedTable">
            <PaymentLinkTable
              tableData={gymCTO.allGymCtos}
              tableColumns={tbColumns}
            />
          </div>
        </>
      )}
    </>
  );
};

export default CTODetail;
